import {mergeStyles} from "office-ui-fabric-react"

export const wrapper = mergeStyles({
    width: "100%",
    height: "70px"
})